export const upkeyPlatformMinusIcon = {
    data: `<svg viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.25C0 0.835786 0.335786 0.5 0.75 0.5H13.25C13.6642 0.5 14 0.835786 14 1.25C14 1.66421 13.6642 2 13.25 2H0.75C0.335786 2 0 1.66421 0 1.25Z" fill="currentColor"/></svg>`,
    name: 'minus'
};